import utils from '@/mixins/utils'

/**
 * Filtra os dados
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object|null} selectedFilterVulnerabilidade
 * @returns {Array}
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterVulnerabilidade
) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.is_acompanhado == null || item.is_acompanhado == '0') {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.is_acompanhado != null && item.is_acompanhado == '1') {
        return true
      }
    })
  }

  if (
    selectedFilterVulnerabilidade != null &&
    Array.isArray(selectedFilterVulnerabilidade.valuesToSearch) &&
    selectedFilterVulnerabilidade.valuesToSearch.length > 0
  ) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (!item.vulnerabilidade) {
        return false
      }

      let vulnerabilidades = []

      try {
        vulnerabilidades = JSON.parse(item.vulnerabilidade)
      } catch (error) {
        vulnerabilidades = []
      }

      const valoresBusca = selectedFilterVulnerabilidade.valuesToSearch.map(
        (v) => v.toLowerCase()
      )

      return vulnerabilidades.some((v) =>
        valoresBusca.includes(String(v).toLowerCase())
      )
    })
  }

  return cadastros_filtrados
}
